import {
  Wifi,
  ShieldCheck,
  Copy,
  Eye,
  EyeOff,
} from "lucide-react";
import { useState } from "react";
import { PageHeader, Card } from "../components/ui";
function WifiPasswords() {
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const wifiNetworks = [
    {
      name: "LSP_JIO_5G",
      password: "Light@2026",
    },
    {
      name: "LSP_JIO_4G",
      password: "Lsp@2026",
    },
    {
      name: "Airtel_LSP_CONF",
      password: "Light@2026",
    },
    {
      name: "LSP TP LINK 5G",
      password: "Speed@2026",
    },
    {
      name: "ACTFIBERNET_5G",
      password: "act12345",
    },
    {
      name: "ACTFIBERNET",
      password: "act12345",
    },
  ];

  const copyPassword = (password) => {
    navigator.clipboard.writeText(password);
  };

  const togglePassword = (index) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="space-y-6">
      <PageHeader title="WiFi Networks" subtitle="Company wireless network credentials." />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {wifiNetworks.map((wifi, index) => (
          <Card key={wifi.name}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center">
                <Wifi size={18} className="text-[#C00000]" />
              </div>
              <div className="min-w-0">
                <h2 className="font-semibold text-[#111111] truncate">{wifi.name}</h2>
                <p className="text-xs text-gray-500">Wireless network</p>
              </div>
            </div>

            <div className="mt-4 bg-gray-50 border border-gray-200 rounded-lg px-4 py-3">
              <div className="flex items-center justify-between">
                <p className="text-xs uppercase tracking-wide text-gray-500">Password</p>
                <div className="flex gap-2">
                  <button
                    onClick={() => togglePassword(index)}
                    className="text-gray-400 hover:text-[#C00000]"
                    aria-label="Show or hide password"
                  >
                    {visiblePasswords[index] ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                  <button
                    onClick={() => copyPassword(wifi.password)}
                    className="text-gray-400 hover:text-[#C00000]"
                    aria-label="Copy password"
                  >
                    <Copy size={16} />
                  </button>
                </div>
              </div>
              <p className="mt-1.5 font-mono text-sm text-[#111111] break-all">
                {visiblePasswords[index] ? wifi.password : "••••••••••"}
              </p>
            </div>
          </Card>
        ))}
      </div>

      <div className="flex items-start gap-3 bg-white border border-gray-200 rounded-xl p-4">
        <ShieldCheck className="text-[#C00000] shrink-0 mt-0.5" size={20} />
        <div>
          <h3 className="text-sm font-semibold text-[#111111]">Security reminder</h3>
          <p className="text-sm text-gray-600 mt-0.5">
            These credentials are intended for Lightspeed Photonics employees only. Please do not share them
            outside the company.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WifiPasswords;
